import React, { useEffect, useState } from 'react'
import { use } from 'react';
import '../css/SimpleAccordion.css';
import { useLocation } from 'react-router-dom';
import { BeatLoader } from 'react-spinners';
const backendUrl = process.env.REACT_APP_BACKEND_URL;
const adminUrl = process.env.REACT_APP_ADMIN_BACKEND_URL;
export default function FilterSidebar({ showFilter, setShowFilter, filter, setFilter, applying }) {
  const location = useLocation();
  const [activeIndex, setActiveIndex] = useState(null);
  const [categories, setCategories] = useState([]);
  const [prints, setPrints] = useState([]);
  const [minPrice, setMinPrice] = useState(0);
  const [maxPrice, setMaxPrice] = useState(50000);
  const [isChanging, setIsChanging] = useState(true)
  const [collections, setCollections] = useState([]);
  const printNames = ["Elephant", "Moon", "Teddy", "Plain"];

  const items = [
    { title: 'Category', content: collections },
    { title: 'Print', content: printNames },
    { title: 'Price', content: 'Email us at support@example.com.' }
  ];

  const filterPopUp = () => {
    const filter = document.getElementById('filter-dropdown');
    setIsChanging(true)
    if (showFilter) {
      filter.style.position = "fixed";
      filter.style.left = "-100rem";
      setShowFilter(false);
    } else {
      filter.style.position = "fixed";
      filter.style.left = "0%";
      setShowFilter(true);
    }
  }
  const handleApply = async () => {
    setFilter({ collection: categories, prints: prints, minPrice: minPrice, maxPrice: maxPrice });
    localStorage.setItem('filter', JSON.stringify({ categories, prints, minPrice, maxPrice }));
    // products();
  };

  const handleCheckboxChangeCat = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setCategories((prev) => [...prev, value]);
    } else {
      setCategories((prev) => prev.filter((category) => category !== value));
    }
  };
  const handleCheckboxChangePrint = (event) => {
    const { value, checked } = event.target;
    if (checked) {
      setPrints((prev) => [...prev, value]);
    } else {
      setPrints((prev) => prev.filter((print) => print !== value));
    }
  };
  const toggle = (index) => {
    setActiveIndex(prevIndex => prevIndex === index ? null : index);
  };
  const onMinChange = (e) => setMinPrice(e.target.value)
  const onMaxChange = (e) => setMaxPrice(e.target.value)

  const getCollections = async () => {
    try {
      const response = await fetch(`${adminUrl}/getCollections`, {
        method: 'GET'
      });
      if (response.ok) {
        const data = await response.json();
        setCollections(data);
      }
    } catch (error) {
      console.log("error occured getting collections data", error)
    }
  }

  useEffect(() => {
    getCollections();
  }, []);

  // useEffect(() => {
  //   console.log(location.pathname)
  // }, [location.pathname])
  return (
    <div>
      <div className='filter-dropdown' id="filter-dropdown">
        <button className='btn btn-cross' onClick={filterPopUp}><i className="fa-solid fa-xmark"></i></button>

        <div className="my-accordion">
          {items.map((item, index) => (
            (location.pathname !== '/collection/all' && item.title === 'Category') ?
              <></>
              :
              <>
                <div className="my-accordion-item" key={index}>
                  <div className="my-accordion-header" onClick={() => toggle(index)}>
                    <span className='title'>{item.title}</span>
                    <span className={`my-accordion-icon ${activeIndex === index ? 'open' : ''}`}>
                      {activeIndex === index ? '–' : '+'}
                    </span>
                  </div>
                  <div className={`my-accordion-content ${activeIndex === index ? 'open' : ''}`}>
                    <div className="my-accordion-inner">
                      {
                        index === 2 &&
                        (
                          <div className='price-filter-group' style={{ display: "flex", flexDirection: "column", minHeight: '100px' }}>
                            <div className='range-container'>
                              <div className='slider'>
                                <div className='range' style={{ left: `${minPrice / 500}%`, width: `${(maxPrice - minPrice) / 500}%` }}></div>
                              </div>
                              <input
                                type="range"
                                className="input-range"
                                min="0"
                                max="50000"
                                value={minPrice}
                                onChange={(e) => setMinPrice(Number(e.target.value))}
                                style={{ position: "absolute", zIndex: 1 }}
                              />
                              <input
                                type="range"
                                className="input-range"
                                min="0"
                                max="50000"
                                value={maxPrice}
                                onChange={(e) => setMaxPrice(Number(e.target.value))}
                                style={{ position: "absolute", zIndex: 2 }}
                              />
                            </div>
                            <div style={{ display: 'flex', alignItems: 'center', gap: '0.5rem' }}>
                              <div className='range-box'>
                                <span className='rupee-style'>₹</span>
                                <input
                                  type="number"
                                  value={minPrice}
                                  onChange={onMinChange}
                                  className='range-inputs'
                                />
                              </div>
                              <span style={{ paddingInline: '1rem', paddingTop: '1.5rem', fontWeight: '500', color: '#5f5b57' }}>To</span>
                              <div className='range-box' >
                                <span className='rupee-style' >₹</span>
                                <input
                                  type="number"
                                  value={maxPrice}
                                  onChange={onMaxChange}
                                  className='range-inputs'
                                />
                              </div>
                            </div>
                          </div>
                        )
                      }
                      {
                        (index === 0) &&
                        item.content.map((collection) => (
                          <div key={collection._id} style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
                            <label className="custom-checkbox">
                              <input 
                              type="checkbox"
                              value={collection.title}
                              onChange={(e)=> handleCheckboxChangeCat(e)}
                               />
                              <span className="checkmark"></span>
                              {collection.title}
                            </label>
                          </div>
                        ))
                      }
                      {
                        index === 1 &&
                        item.content.map((print, index) => (
                          <div key={index} style={{ marginBottom: '0.5rem', textAlign: 'left' }}>
                            <label className="custom-checkbox">
                              <input
                                type="checkbox"
                                value={print}
                                onChange={(e) => handleCheckboxChangePrint(e)}
                              />
                              <span className="checkmark"></span>
                              {print}
                            </label>
                          </div>
                        ))
                      }

                    </div>
                  </div>
                </div>
              </>
          ))}
        </div>
        <div>
          <button className='btn-cart welcome-add-cart text-center' style={{ width: '100%' }} onClick={handleApply}>{applying? <BeatLoader color="#f7a5b9"/>: "Apply"}</button>
        </div>
      </div>
    </div>
  )
}
